<script>
	export let bg_color;
	export let text;
</script>

<span class={`rounded-pill badge bg-${bg_color} ${$$props.class}`}>{text}</span>

<style lang="scss">
    .badge {
        margin: var(--margin) !important;
        padding: 7px 18px 5px !important;
        width: 70px;
        height: 24px;
        color: black;
        font-size: 12px !important;
        line-height: 12px !important;

        &:hover {
            color: inherit !important;
        }
    }
</style>
